import React, { useState, useEffect } from "react";
import "../../Sidebar/Pages/AccountSetting.css";
import { fetchAccountData, fetcOrganizationData } from "../../actioncreators/actioncreators";

const AccountSetting = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchDashboardData1 = async () => {
    setIsLoading(true);
    try {
      const response = await fetcOrganizationData();
      setData(response);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData1();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (isLoading) {
    return (
      <div className="account-settings-wrapper">
        <div className="theme-loading">
          <div className="theme-loader"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="account-settings-wrapper">
      <div className="theme-container">
        <div className="theme-header">
          <div className="d-flex align-items-center">
          <i className="bi bi-buildings me-2 orange-icon"></i>
          <h3>Organization Details</h3>
          </div>
        </div>

        <div className="theme-content">
          {/* Organization Information Section */}
          <div className="theme-card">

            <div className="org-identity">
              <div className="org-logo">
                {data?.organizationDetails?.org_name?.charAt(0).toUpperCase() || "O"}
              </div>
              <div>
                <div className="d-flex align-items-center">
                  <h4>{data?.organizationDetails?.org_name}</h4>
                  <div className="status-badge org-status-badge">
                    <span>
                      <i className="bi bi-check-circle-fill me-1"></i>
                      {data?.organizationDetails?.status || "Active"}
                    </span>
                  </div>
                </div>
                <p>{data?.organizationDetails?.org_type}</p>
              </div>
            </div>

            <div className="theme-grid">
              <div className="theme-item">
                <i className="bi bi-envelope"></i>
                <span className="theme-item-content">{data?.organizationDetails?.email || "-"}</span>
              </div>

              <div className="theme-item">
                <i className="bi bi-telephone"></i>
                <span className="theme-item-content">{data?.organizationDetails?.mobile || "-"}</span>
              </div>

              <div className="theme-item">
                <i className="bi bi-people"></i>
                <span className="theme-item-content">
                  {data?.organizationDetails?.org_size
                    ? `${data?.organizationDetails?.org_size} employees`
                    : "-"}
                </span>
              </div>

              <div className="theme-item">
                <i className="bi bi-calendar"></i>
                <span className="theme-item-content">
                  {formatDate(data?.organizationDetails?.creation_date_and_time)}
                </span>
              </div>
            </div>
          </div>          {/* Section Divider */}
          <div className="section-divider"></div>

          {/* Address Information Section */}
<div className="theme-card address-section">
  <div className="section-title">
    <i className="bi bi-geo-alt me-2"></i>
    Address Information
  </div>

  {data?.organizationDetails &&
    (data.organizationDetails.address_line_1 ||
      data.organizationDetails.address_line_2 ||
      data.organizationDetails.city ||
      data.organizationDetails.pincode ||
      data.organizationDetails.state ||
      data.organizationDetails.country) ? (
    <div className="theme-grid">
    {(data.organizationDetails.address_line_1 ||
  data.organizationDetails.city ||
  data.organizationDetails.pincode) && (
  <div className="theme-item">
    <i className="bi bi-house"></i>

    <span
      className="theme-item-content"
      style={{ whiteSpace: "normal", wordBreak: "break-word" }}
    >
      {[
        data.organizationDetails.address_line_1,
        data.organizationDetails.city,
        data.organizationDetails.pincode,
      ]
        .filter(Boolean)
        .join(", ")}
    </span>
  </div>
)}



      {data.organizationDetails.state && (
        <div className="theme-item">
          <i className="bi bi-map"></i>
          <span className="theme-item-content">{data.organizationDetails.state}</span>
        </div>
      )}

      {data.organizationDetails.country && (
        <div className="theme-item">
          <i className="bi bi-globe"></i>
          <span className="theme-item-content">{data.organizationDetails.country}</span>
        </div>
      )}
    </div>
  ) : (
    <div className="empty-address">
      <i className="bi bi-geo-alt"></i>
      <p>No address information available</p>
    </div>
  )}
</div>

        </div>
      </div>
    </div>
  );
};

export default AccountSetting;
